import ServiceVendorRecords from "../../../jsx/components/Dashboard/ServiceVendorRecords/servicevendorrecords";

const ServiceVendorRecordsWrapper = () => {
  return <ServiceVendorRecords />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.senior_underwriter,
];
export default constore(ServiceVendorRecordsWrapper);
